import { every } from "lodash";
import { FiltersConfigTemplateElement } from "PFTypes/filters_config";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

type UseIsFieldRequiredProps = {
  fieldPrefix: string;
  template: FiltersConfigTemplateElement;
};

export const useIsFieldRequired = ({ fieldPrefix, template }: UseIsFieldRequiredProps) => {
  const { watch } = useFormContext();

  const isFieldEnabled = useCallback(
    (property: string): boolean => {
      const requiredByValuesRules = template.required_by_values?.[property];
      const requiredByValuesFields = Object.keys(requiredByValuesRules || {});

      if (requiredByValuesFields.length === 0) {
        return template.inputs[property].required;
      }

      const values = watch(requiredByValuesFields.map((field) => `${fieldPrefix}.${field}`));

      return every(values, (value, index) => {
        const fieldName = requiredByValuesFields[index];
        const condition = requiredByValuesRules[fieldName];

        if (Array.isArray(condition)) {
          return condition.includes(value);
        }

        if (typeof condition === "boolean") {
          return condition === Boolean(value);
        }

        return condition === value;
      });
    },
    [fieldPrefix, template, watch]
  );

  return isFieldEnabled;
};
